import { render, staticRenderFns } from "./FormOrganisationLocaleNotes.vue?vue&type=template&id=09010280&scoped=true&"
import script from "./FormOrganisationLocaleNotes.vue?vue&type=script&lang=js&"
export * from "./FormOrganisationLocaleNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09010280",
  null
  
)

export default component.exports